/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable import/no-unresolved */
import {
    Breadcrumb, Button, Panel, Tab, Tabs,
} from 'appkit-react';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import Loader from '../../../Shared/components/Loader';
import FFIEC009AuditLogs from '../containers/FFIEC009AuditLogs';
import '../styles/ffiec009.scss';
import FFIEC009ClassifyResult from './FFIEC009ClassifyResult';
import FFIEC009Comments from '../containers/FFIEC009Comments';
import FFIEC009ResultReportModal from './FFIEC009ResultReportModal';
import FFIEC009ResultsAccordian from './FFIEC009ResultsAccordian';

const FFIEC009Results = ({
    breadcrumbItems, onNavigate, columns, criteria, fetchData, data, pages, pagesize,
    setPageSize, setPageNumber, auditLog, refetch, showResultReportModal,
    setShowResultReportModal, rowData, failedRowDataLoading, pageSizeOptions,
}) => {
    const history = useHistory();
    const [showClassifyResult, setShowClassifyResult] = useState(false);
    if (failedRowDataLoading) {
        return (
            <Loader />
        );
    }
    if (showResultReportModal) {
        return (
            <FFIEC009ResultReportModal
                setShowResultReportModal={setShowResultReportModal}
                resultData={rowData}
            />
        );
    }
    return (
        <>

            <div className="true-comply-ffiec009-results_layout">
                <div className="true-comply-ffiec009-results_column-2">
                    <Breadcrumb items={breadcrumbItems} />
                    <Row>
                        <Col md={4}>
                            <div className="a-h2 title-label">
                                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.goBack()} role="presentation" />
                                {`Rule #${criteria?.ruleId || ''} Results`}
                            </div>
                        </Col>
                        <Col className="classyfy_btn_container">
                            <Row>
                                <Col style={{ textAlign: 'right' }}>
                                    <span>
                                        <Button size="lg" style={{ marginLeft: '1rem' }} onClick={() => setShowClassifyResult(true)}>
                                            CLASSIFY RESULTS
                                        </Button>
                                        {showClassifyResult
                                            && (
                                                <FFIEC009ClassifyResult
                                                    setShowClassifyResult={setShowClassifyResult}
                                                    refetch={auditLog.refetch}
                                                    refetchTestData={refetch}
                                                />
                                            )}
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    {/* Import accordian results and Diagonstic criteria component */}
                    <FFIEC009ResultsAccordian
                        criteria={criteria}
                        columns={columns}
                        fetchData={fetchData}
                        data={data}
                        pages={pages}
                        pagesize={pagesize}
                        setPageSize={setPageSize}
                        setPageNumber={setPageNumber}
                        pageSizeOptions={pageSizeOptions}
                    />

                    <Panel style={{ marginTop: '1rem', marginBottom: '2rem' }}>
                        <Tabs defaultValue="2" className="a-tab-item-padding-10" size="md">
                            {/* <Tab value="1" label="REMEDIATION">
                                {remediation && remediation.length ? <Remediation failedTestsData={failedTestsData} refetch={auditLog.refetch} /> : (
                                    <div className="a-h4">
                                        Remediation is not allowed for passed test cases
                                    </div>
                                )}
                            </Tab> */}
                            <Tab value="2" label="COMMENTS">
                                <FFIEC009Comments refetch={auditLog.refetch} />
                            </Tab>
                            <Tab value="3" label="AUDIT LOG">
                                <FFIEC009AuditLogs data={auditLog.data && auditLog.data.getAuditLogsForFFIEC009} />
                            </Tab>
                        </Tabs>
                    </Panel>
                </div>
            </div>
        </>
    );
};

export default FFIEC009Results;
